import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import {
  TabloStaticTextConfig,
  TabloStaticTextConfigOptions,
  TabloTextConfigOptions,
} from '@ui/tablo-generator/types';
import { TypedFormBuilder } from '@ui/form/TypedFormBuilder';
import { filter, tap } from 'rxjs/operators';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';

@Component({
    selector: 'lib-tablo-static-text-editor',
    templateUrl: './tablo-static-text-editor.component.html',
    styleUrls: ['./tablo-static-text-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabloStaticTextEditorComponent
  extends AliveState
  implements OnInit
{
  model = this.fb.typedGroup<TabloStaticTextConfigOptions>({
    text: [''],
    align: ['left'],
    fontSize: [50],
    font: ['Arial'],
    verticalAlign: ['top'],
    color: ['#000000'],
    headerFontSize: [50],
    headerFont: ['Arial'],
    headerAlign: ['left'],
    headerColor: ['#000000'],
    fontLatterSpacing: [1],
    headerFontLatterSpacing: [1],
    background: ['rgba(0,0,0,0)'],
    borderRadius: [0],
    padding: [0],
    uppercase: [false],
    headerUppercase: [false],
  });
  selfUpdate = false;
  isGroup = false;
  @Output() updated = new EventEmitter<TabloTextConfigOptions>();
  @Input() set currentConfig(config: TabloStaticTextConfig) {
    this.selfUpdate = true;
    this.model.patchValue(config.config);
    this.selfUpdate = false;
  }
  constructor(private fb: TypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.model.valueChanges.pipe(
        filter(() => !this.selfUpdate),
        tap((value) => this.updated.emit(value)),
      ),
    );
  }
}
